export const ENV_CONFIG_URL = '/assets/data/envConfig.json';
